var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 228,
    height: 228,
    rx: 35,
    fill: "#00B8E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4286 63V98.4406M142.571 63V98.4406M81.8571 116.161H103.286M146.143 116.161H124.714M81.8571 137.425H103.286M124.714 137.425H146.143M71.1429 80.7203H156.857C160.802 80.7203 164 83.8938 164 87.8084V158.69C164 162.604 160.802 165.778 156.857 165.778H71.1429C67.198 165.778 64 162.604 64 158.69V87.8084C64 83.8938 67.198 80.7203 71.1429 80.7203Z",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentBooking);
export default __webpack_public_path__ + "static/media/AppointmentBooking.58439c2252fc1b9201bed187925fd570.svg";
export { ForwardRef as ReactComponent };